document.addEventListener('DOMContentLoaded', function () {
  const stars = document.querySelectorAll('.star');
  stars.forEach((star, index) => {
    star.style.setProperty('--star-index', index);
  });

  // Animate the number count
  function animateNumber(element, start, end, duration) {
    let startTime = null;

    function step(currentTime) {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const value = Math.floor(progress * (end - start) + start);
      element.textContent = value.toLocaleString() + '+';
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        // Convert the number to 'k' format after the animation completes
        const finalValue = Math.floor(end / 1000) + 'k+';
        element.textContent = finalValue;
      }
    }

    requestAnimationFrame(step);
  }

  const numberElement = document.querySelector('.animated-number');
  animateNumber(numberElement, 0, 10000, 2000);
});







 function animateCountUp($element, finalValue) {
    let currentValue = 0;
    const increment = Math.ceil(finalValue / 100); // Increase rate
    const interval = setInterval(() => {
      if (currentValue >= finalValue) {
        clearInterval(interval);
        $element.text(finalValue + '%'); // Ensure exact final value
      } else {
        currentValue += increment;
        $element.text(currentValue + '%');
      }
    }, 20); // Speed of the animation
  }

  // Trigger animation on scroll
  $(window).on('scroll', function() {
    $('.percent_box').each(function() {
      const boxTop = $(this).offset().top;
      const windowBottom = $(window).scrollTop() + $(window).height();
      
      // Check if the box is visible in the viewport
      if (windowBottom > boxTop + $(this).outerHeight() / 2) {
        const $span = $(this).find('.percent');
        const finalValue = parseInt($span.text());
        
        // If not yet animated, trigger count up
        if (!$span.hasClass('animated')) {
          $span.addClass('animated'); // Prevent re-triggering
          animateCountUp($span, finalValue);
        }
      }
    });
  });


$(document).ready(function(){
  var img = $('.prod_looking_young.row-rvrs .l_flx_right img');
  var width = img.width();
  img.css('height', width);
});



$(document).ready(function () {
    // Function to process and append inputs to `.line_input`
    function processSelectedInputs(label) {
        // Clear previous content in `.line_input`
        $('.line_input').empty();

        // Iterate through each `.color_select_box` within the specified label
        label.find('.color_select_box').each(function () {
            // Find all `input` elements inside `.selected_item_item`
            $(this).find('.selected_item_item input').each(function (index) {
                // Get the full HTML of the input element
                var inputHtml = $(this)[0].outerHTML;

                // Append the input HTML to `.line_input`
                $('.line_input').append(inputHtml);
            });
        });

        // Update the name attribute of each appended input
        $('.line_input input').each(function (index) {
            // Set the name as "properties[Color [inputIndex]]"
            $(this).attr('name', `properties[Color ${index + 1}]`);
        });
    }

    // On page load, process the inputs of the checked `label.bundle_new`
    const checkedLabel = $('.product-form__input input[type=radio]:checked+label.bundle_new');
    if (checkedLabel.length) {
        processSelectedInputs(checkedLabel);
    }

    // On click of `label.bundle_new`, process the inputs
    $(document).on('click', 'label.bundle_new', function () {
        processSelectedInputs($(this));
    });
});




$(document).on('click', '.color_select_box', function () {
    $(this).toggleClass('active');
});

$(document).on('click', '.color_select_box .line_item .item_item', function () {
    var itemHtml = $(this).html();
    $(this).closest('.color_select_box').find('.selected_item_item').empty();
    $(this).closest('.color_select_box').find('.selected_item_item').append(itemHtml);
});

$(document).on('click', '.color_value', function () {
$(this).parents('.color-thumb-wrap').find('.individual_swatches').trigger('click');
});

